import * as React from 'react';
import { Box, Loader, Text, Modal } from '@wix/design-system';
import { DataHooks } from '../../constants/dataHooks';

interface ModalLoaderProps {
  text?: string;
}

export const ModalLoader: React.FC<ModalLoaderProps> = ({ text }) => {
  return (
    <Modal isOpen={true}>
      <Box direction="vertical" align="center" gap="20px">
        <Loader dataHook={DataHooks.ModalLoader} />
        {!!text && (
          <Text size="tiny" weight="normal" light>
            {text}
          </Text>
        )}
      </Box>
    </Modal>
  );
};
